// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_fieldset__\\+DK6q {
  border: 1px dashed #ccc;
  min-width: unset;
  max-width: 100%;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.styles_fieldset__\\+DK6q legend {
  font-weight: 500;
  color: #6ba7a8;
  padding: 0 8px;
}
.styles_fieldset__\\+DK6q div {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}
.styles_fieldset__\\+DK6q select,
.styles_fieldset__\\+DK6q input {
  padding: 4px;
  border: none;
  border-radius: 0.5rem;
  font-size: 14px;
  resize: none;
}
.styles_fieldset__\\+DK6q select::placeholder,
.styles_fieldset__\\+DK6q input::placeholder {
  color: rgba(0, 0, 0, 0.8);
}
.styles_fieldset__\\+DK6q select:focus,
.styles_fieldset__\\+DK6q input:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptList/FilterSort/Sorter/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AAAE;EACE,gBAAA;EACA,cAAA;EACA,cAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAEJ;AACE;;EAEE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AACJ;AACI;;EACE,yBAAA;AAEN;AACI;;EACE,aAAA;AAEN","sourcesContent":[".fieldset {\n  border: 1px dashed #ccc;\n  min-width: unset;\n  max-width: 100%;\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  legend {\n    font-weight: 500;\n    color: #6ba7a8;\n    padding: 0 8px;\n  }\n  div {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n  }\n\n  select,\n  input {\n    padding: 4px;\n    border: none;\n    border-radius: 0.5rem;\n    font-size: 14px;\n    resize: none;\n\n    &::placeholder {\n      color: rgba(0, 0, 0, 0.8);\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldset": `styles_fieldset__+DK6q`
};
export default ___CSS_LOADER_EXPORT___;
